import Vue from 'vue'
const roles = {
  users_allow: ['users_show', 'users_add', 'users_edit', 'users_delete'],
  customers_allow: [
    'customers_show',
    'customers_add',
    'customers_edit',
    'customers_delete',
    'customers_edit_balance'
  ],
  quotations_allow: [
    'quotations_show',
    'quotations_add',
    'quotations_edit',
    'quotations_edit_product',
    'quotations_delete',
    'quotations_edit_status'
  ],
  invoices_allow: [
    'invoices_show',
    'invoices_add',
    'invoices_edit',
    'invoices_delete',
    'invoices_edit_product',
    'invoices_edit_status'
  ],
  saleReturns_allow: [
    'sale_returns_show',
    'sale_returns_add',
    'sale_returns_edit',
    'sale_returns_edit_product',
    'sale_returns_delete',
    'sale_returns_edit_status'
  ],
  orders_allow: [
    'orders_show',
    'orders_add',
    'orders_edit',
    'orders_delete',
    'orders_edit_date',
    'orders_edit_product',
    'orders_transfers',
    'orders_edit_status'
  ],
  suppliers_allow: [
    'suppliers_show',
    'suppliers_add',
    'suppliers_delete',
    'suppliers_edit',
    'suppliers_edit_balance'
  ],
  bills_allow: [
    'bills_show',
    'bills_add',
    'bills_edit',
    'bills_delete',
    'bills_edit_product',
    'bills_edit_status'
  ],
  purchaseReturns_allow: [
    'purchase_returns_show',
    'purchase_returns_add',
    'purchase_returns_edit',
    'purchase_returns_edit_product',
    'purchase_returns_delete',
    'purchase_returns_edit_status'
  ],

  safes_allow: ['safes_add', 'safes_show', 'safes_edit', 'safes_edit_balance', 'safes_delete'],
  financial_dependents_allow: [
    'financial_dependents_add',
    'financial_dependents_show',
    'financial_dependents_edit',
    'financial_dependents_edit_balance',
    'financial_dependents_delete'
  ],
  financial_settlements_allow: [
    'financial_settlements_add',
    'financial_settlements_show',
    'financial_settlements_edit',
    'financial_settlements_edit_balance',
    'financial_settlements_delete'
  ],

  safesDeposits_allow: [
    'safes_deposits_show',
    'safes_deposits_add',
    'safes_deposits_edit',
    'safes_deposits_delete',
    'safes_deposits_edit_status'
  ],
  safesWithdrawals_allow: [
    'safes_withdrawals_show',
    'safes_withdrawals_add',
    'safes_withdrawals_edit',
    'safes_withdrawals_delete',
    'safes_withdrawals_edit_status'
  ],
  safesTransfers_allow: [
    'safes_transfers_show',
    'safes_transfers_add',
    'safes_transfers_edit',
    'safes_transfers_delete',
    'safes_transfers_edit_status'
  ],
  bankAccounts_allow: [
    'bank_accounts_show',
    'bank_accounts_add',
    'bank_accounts_edit',
    'bank_accounts_edit_balance',
    'bank_accounts_delete'
  ],
  salesPayments_allow: [
    'sales_payments_add',
    'sales_payments_show',
    'sales_payments_edit',
    'sales_payments_edit_item',
    'sales_payments_delete',
    'sales_payments_edit_status'
  ],
  salesInstallments_allow: [
    'sales_installments_show',
    'sales_installments_add',
    'sales_installments_edit',
    'sales_installments_delete'
  ],
  purchaseInstallments_allow: [
    'purchase_installments_show',
    'purchase_installments_add',
    'purchase_installments_edit',
    'purchase_installments_delete'
  ],
  purchasePayments_allow: [
    'purchase_payments_show',
    'purchase_payments_edit',
    'purchase_payments_edit_item',
    'purchase_payments_delete',
    'purchase_payments_add',
    'purchase_payments_edit_status'
  ],
  taxpayments_allow: [
    'tax_payments_show',
    'tax_payments_add',
    'tax_payments_edit',
    'tax_payments_edit_item',
    'tax_payments_delete'
  ],
  expenses_allow: [
    'expenses_show',
    'expenses_edit',
    'expenses_delete',
    'expenses_add',
    'expenses_edit_item',
    'expenses_edit_status'
  ],
  stores_allow: [
    'stores_add',
    'stores_show',
    'stores_edit',
    'stores_orders_add',
    'stores_orders_edit_item',
    'stores_delete',
    'stores_orders_show',
    'stores_orders_delete',
    'stores_edit_balance'
  ],
  products_allow: [
    'products_add',
    'products_show',
    'products_delete',
    'products_edit',
    'materials_show',
    'materials_add',
    'materials_edit',
    'materials_delete'
  ],
  storesDeposits_allow: [
    'stores_deposits_show',
    'stores_deposits_add',
    'stores_deposits_edit',
    'stores_deposits_edit_item',
    'stores_deposits_delete',
    'stores_deposits_edit_status'
  ],
  storesWithdrawals_allow: [
    'stores_withdrawals_add',
    'stores_withdrawals_show',
    'stores_withdrawals_edit',
    'stores_withdrawals_edit_item',
    'store_withdrawals_edit_item',
    'stores_withdrawals_delete',
    'stores_withdrawals_edit_status'
  ],

  storesTransfers_allow: [
    'stores_transfers_show',
    'stores_transfers_add',
    'stores_transfers_edit',
    'stores_transfers_edit_item',
    'stores_transfers_delete',
    'stores_transfers_edit_status'
  ],
  storesSettlements_allow: [
    'stores_settlements_show',
    'stores_settlements_show_allow_branch',
    'stores_settlements_add',
    'stores_settlements_edit',
    'stores_settlements_delete',
    'stores_settlements_edit_status'
  ],
  salesCheques_allow: [
    'sales_cheques_show',
    'sales_cheques_edit',
    'sales_cheques_edit_item',
    'sales_cheques_delete',
    'sales_cheques_add',
    'sales_cheques_edit_status'
  ],
  loyal_points_allow: [
    'loyal_points_show',
    'loyal_points_edit',
    'loyal_points_delete',
    'loyal_points_add'
  ],
  credit_recharges_allow: [
    'credit_recharges_show',
    'credit_recharges_add',
    'credit_recharges_edit',
    'credit_recharges_delete'
  ],
  credit_consumptions_allow: [
    'credit_consumptions_show',
    'credit_consumptions_add',
    'credit_consumptions_edit',
    'credit_consumptions_delete'
  ],
  purchaseCheques_allow: [
    'purchase_cheques_add',
    'purchase_cheques_show',
    'purchase_cheques_edit',
    'purchase_cheques_edit_item',
    'purchase_cheques_delete',
    'purchase_cheques_edit_status'
  ],

  salesDiscounts_allow: [
    'sales_discounts_show',
    'sales_discounts_add',
    'sales_discounts_edit_item',
    'sales_discounts_edit',
    'sales_discounts_delete',
    'sales_discounts_edit_status'
  ],
  purchaseDiscounts_allow: [
    'purchase_discounts_show',
    'purchase_discounts_add',
    'purchase_discounts_edit_item',
    'purchase_discounts_edit',
    'purchase_discounts_delete',
    'purchase_discounts_edit_status'
  ],
  discount_codes_allow: [
    'discount_codes_show',
    'discount_codes_add',
    'discount_codes_edit',
    'discount_codes_delete',
    'discount_codes_edit_item'
  ],

  employees_allow: [
    'employees_show',
    'employees_add',
    'employees_edit',
    'employees_edit_balance',
    'employees_delete'
  ],
  employeesSalaries_allow: [
    'employees_salaries_show',
    'employees_salaries_add',
    'employees_salaries_edit',
    'employees_salaries_edit_item',
    'employees_salaries_delete',
    'employees_salaries_edit_status'
  ],
  employeesSalarySheets_allow: [
    'employees_salary_sheets_show',
    'employees_salary_sheets_add',
    'employees_salary_sheets_edit',
    'employees_salary_sheets_show_allow',
    'employees_salary_sheets_show_allow_branch',
    'employees_salary_sheets_delete',
    'employees_salary_sheets_edit_status'
  ],
  employeesIncentives_allow: [
    'employees_incentives_show',
    'employees_incentives_add',
    'employees_incentives_edit',
    'employees_incentives_edit_item',
    'employees_incentives_delete',
    'employees_incentives_edit_status'
  ],
  employeesDeductions_allow: [
    'employees_deductions_show',
    'employees_deductions_add',
    'employees_deductions_edit',
    'employees_deductions_edit_item',
    'employees_deductions_delete',
    'employees_deductions_edit_status'
  ],
  employeesWithdrawals_allow: [
    'employees_withdrawals_show',
    'employees_withdrawals_add',
    'employees_withdrawals_edit',
    'employees_withdrawals_edit_item',
    'employees_withdrawals_delete',
    'employees_withdrawals_edit_status'
  ],
  shifts_allow: ['shifts_show', 'shifts_add', 'shifts_edit', 'shifts_edit_item', 'shifts_delete'],
  employees_shifts_allow: [
    'employees_shifts_show',
    'employees_shifts_add',
    'employees_shifts_edit',
    'employees_shifts_edit_item',
    'employees_shifts_delete'
  ],
  employees_shifts_attendance_allow: [
    'employees_shift_attendance_show',
    'employees_shift_attendance_add',
    'employees_shift_attendance_edit',
    'employees_shift_attendance_edit_item',
    'employees_shift_attendance_delete'
  ],
  penalties_allow: ['penalties_show', 'penalties_add', 'penalties_edit', 'penalties_delete'],
  partners_allow: ['partners_show', 'partners_add', 'partners_edit', 'partners_delete'],
  partnersDeposits_allow: [
    'partners_deposits_show',
    'partners_deposits_add',
    'partners_deposits_edit',
    'partners_deposits_delete',
    'partners_deposits_edit_item',
    'partners_deposits_edit_status'
  ],
  partnersWithdrawals_allow: [
    'partners_withdrawals_show',
    'partners_withdrawals_add',
    'partners_withdrawals_edit',
    'partners_withdrawals_edit_item',
    'partners_withdrawals_delete',
    'partners_withdrawals_edit_status'
  ],
  partnersSettlements_allow: [
    'partners_settlements_show',
    'partners_settlements_edit',
    'partners_settlements_edit_item',
    'partners_settlements_delete',
    'partners_settlements_edit_status'
  ],
  partnersProfits_allow: [
    'partners_profits_show',
    'partners_profits_add',
    'partners_profits_edit',
    'partners_profits_edit_item',
    'partners_profits_delete',
    'partners_profits_edit_status'
  ],

  capitals_allow: ['capitals_show', 'capitals_add', 'capitals_edit', 'capitals_delete'],
  manufacturingModels_allow: [
    'manufacturing_models_show',
    'manufacturing_models_add',
    'manufacturing_models_delete',
    'manufacturing_models_edit',
    'manufacturing_models_edit_item'
  ],
  manufacturingOperations_allow: [
    'manufacturing_operations_add',
    'manufacturing_operations_show',
    'manufacturing_operations_edit',
    'manufacturing_operations_edit_item',
    'manufacturing_operations_delete',
    'manufacturing_operations_edit_status'
  ],
  manufacturingDeposits_allow: [
    'manufacturing_deposits_add',
    'manufacturing_deposits_show',
    'manufacturing_deposits_edit',
    'manufacturing_deposits_edit_item',
    'manufacturing_deposits_delete'
  ],
  manufacturingWithdrawals_allow: [
    'manufacturing_withdrawals_add',
    'manufacturing_withdrawals_show',
    'manufacturing_withdrawals_edit',
    'manufacturing_withdrawals_edit_item',
    'manufacturing_withdrawals_delete'
  ],
  manufacturingTransfers_allow: [
    'manufacturing_transfers_add',
    'manufacturing_transfers_show',
    'manufacturing_transfers_edit',
    'manufacturing_transfers_edit_item',
    'manufacturing_transfers_delete'
  ],
  cities_allow: ['cities_show', 'cities_add', 'cities_edit', 'cities_delete'],
  deliveries_allow: ['deliveries_show', 'deliveries_add', 'deliveries_edit', 'deliveries_delete'],
  pickup_locations_allow: [
    'pickup_locations_show',
    'pickup_locations_add',
    'pickup_locations_edit',
    'pickup_locations_delete'
  ],
  shipping_addresses_allow: [
    'shipping_addresses_show',
    'shipping_addresses_add',
    'shipping_addresses_edit',
    'shipping_addresses_delete'
  ],
  shipping_operations_allow: [
    'shipping_operations_show',
    'shipping_operations_add',
    'shipping_operations_edit',
    'shipping_operations_delete',
    'shipping_operations_show_allow',
    'shipping_operations_show_allow_branch'
  ],
  pointOfSales_allow: [
    'point_of_sales_show',
    'point_of_sales_add',
    'point_of_sales_edit',
    'point_of_sales_delete',
    'point_of_sales_show_balance',
    'point_of_sales_sessions_edit',
    'point_of_sales_sessions_show',
    'point_of_sales_sessions_add'
  ],
  callCenters_allow: [
    'call_centers_show',
    'call_centers_add',
    'call_centers_edit',
    'call_centers_delete'
  ],
  accountsDeposits_allow: [
    'accounts_deposits_show',
    'accounts_deposits_add',
    'accounts_deposits_edit',
    'accounts_deposits_delete'
  ],
  accountsWithdrawals_allow: [
    'accounts_withdrawals_show',
    'accounts_withdrawals_add',
    'accounts_withdrawals_edit',
    'accounts_withdrawals_delete'
  ],
  products_insurances_allow: [
    'products_insurances_show',
    'products_insurances_add',
    'products_insurances_edit',
    'products_insurances_edit_item',
    'products_insurances_delete',
    'products_insurances_show_allow',
    'products_insurances_show_allow_branch'
  ],
  reports_allow: [
    'reports_show',
    'accounting_show',
    'accounting_restrictions_add',
    'accounting_restrictions_edit',
    'accounting_restrictions_delete',
    'accounting_restrictions_show',
    'accounting_restrictions_show_allow'
  ],

  companies_allow: ['companies_show', 'companies_add', 'companies_edit', 'companies_delete'],
  pickupLocationsDeposits_allow: ['pickupLocations_deposits_add'],
  pickupLocationsWithdrawals_allow: ['pickupLocations_withdrawals_add'],
  pickupLocationsTransfers_allow: ['pickupLocations_transfers_add'],
  branches_allow: [
    'branches_show',
    'branches_allow',
    'branches_add',
    'branches_edit',
    'branches_delete'
  ],
  stores_orders_allow: [
    'stores_orders_show',
    'stores_orders_add',
    'stores_orders_delete',
    'stores_orders_edit_item'
  ],
  purchaseOrders_allow: [
    'purchase_orders_show',
    'purchase_orders_add',
    'purchase_orders_edit',
    'purchase_orders_delete',
    'purchase_orders_edit_product'
  ],
  global: [
    'options_show',
    'profile_edit',
    'roles_show',
    'signatures_edit',
    'signatures_delete',
    'purchase_returns_edit_product',
    'purchase_orders_edit_product',
    'roles_add',
    'roles_edit',
    'roles_delete',
    'users_edit',
    'users_delete',
    'users_add',
    'users_show',
    'incomes_add',
    'incomes_edit',
    'incomes_delete',
    'partners_settlements_add',
    'reports_earning_show',
    'buckup_allow',
    'products_show_quantity',
    'pickupLocations_transfers_add',
    'pickupLocations_deposits_add',
    'pickupLocations_withdrawals_add',
    'pickupLocations_delete',
    'stores_orders_add',
    'payments_sections_add',
    'history_show',
    'incomes_edit_status',
    'financial_settlements_edit_status',
    'transaction_edit_status',
    'auto_transaction_edit_status',
    'store_orders_edit_status'
  ]
}
Vue.prototype.$checkRole = function (userRole) {
  const siteRole = Object.entries(roles).find(([, valueArray]) =>
    valueArray.includes(userRole)
  )?.[0]
  return (
    (siteRole == 'global' || Vue.prototype.$site[siteRole]) &&
    (Vue.prototype.$user.admin || Vue.prototype.$user.role[userRole])
  )
}
Vue.prototype.$checkMultiRoles = function (roles) {
  let result = false
  roles.map((role) => {
    const roleResult = Vue.prototype.$checkRole(role)
    if (roleResult) result = true
  })
  return result
}

Vue.prototype.$checkStatusRoles = (companyKey, rolesKey) => {
  const { admin, role } = Vue.prototype.$user
  const defaultOption = Vue.prototype.$option[companyKey]

  if (admin === 1) {
    return defaultOption
  }

  const userRoles = role[rolesKey] || []
  return userRoles.length === 0 ? defaultOption : userRoles
}

Vue.prototype.$selectDefaultStatus = (rolesArray, defaultStatus) =>
  rolesArray.includes(defaultStatus) ? defaultStatus : rolesArray[0] || null

Vue.prototype.$checkEditStatus = (statusId, arrayKey) => {
  if (Vue.prototype.$user.admin) {
    return true
  }
  if (Vue.prototype.$user.role[arrayKey].length == 0) {
    return true
  }
  if (Vue.prototype.$user.role[arrayKey].includes(statusId)) {
    return true
  }
  return false
}
